import clsx from 'clsx';
import React from 'react';

import { Button } from '../BaseButton/Button';

type PrimaryButtonV2Props = Omit<
  JSX.IntrinsicElements['button'],
  'background' | 'fontDecoration' | 'extraClassNames' | 'color'
> & {
  secondaryIcon?: React.ReactNode;
};

export const PrimaryButtonV2 = ({
  onClick,
  disabled = false,
  children,
  className,
  secondaryIcon,
  type = 'button',
  ...props
}: PrimaryButtonV2Props): JSX.Element => (
  <Button
    type={type}
    onClick={onClick}
    disabled={disabled}
    extraClassNames={clsx(
      'hover:enabled:cursor-pointer hover:disabled:cursor-not-allowed h-min',
      className
    )}
    background="disabled:bg-main-200 bg-main hover:enabled:bg-negative"
    fontDecoration="no-underline"
    color="disabled:text-main-500 text-negative hover:text-main"
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
  >
    {children}
    {secondaryIcon && <span className="text-main-500">{secondaryIcon}</span>}
  </Button>
);
